export default {"src":"/_next/static/media/CellWhite.2acafea3.svg","height":58,"width":38,"blurWidth":0,"blurHeight":0};